import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'caststring' })
export class CastStringPipe implements PipeTransform {
  transform(n: any): string { return n as string; }
}
